import React, {Component} from 'react';
import {FaIcon} from "../FaIcon";
import {getColumnData} from "./columns";
import { withTranslation } from 'react-i18next';


class ColumnVisibilityButtonClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
        this.containerRef = React.createRef();
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleToggleColumn = this.handleToggleColumn.bind(this);
        this.handleShowAll = this.handleShowAll.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.state.isOpen && this.containerRef.current && !this.containerRef.current.contains(event.target)) {
            this.setState({isOpen: false});
        }
    }

    getHiddenColumns() {
        const hidden = this.props.hiddenColumns;
        return Array.isArray(hidden) ? hidden : [];
    }

    isColumnVisible(columnId) {
        return !this.getHiddenColumns().includes(columnId);
    }

    toggleDropdown(event) {
        event.preventDefault();
        this.setState({isOpen: !this.state.isOpen});
    }

    handleToggleColumn(columnId) {
        const hidden = this.getHiddenColumns();
        let next;
        if (hidden.includes(columnId)) {
            next = hidden.filter((id) => id !== columnId);
        } else {
            next = [...hidden, columnId];
        }
        this.props.onHiddenColumnsChange(next);
    }

    handleShowAll(event) {
        event.preventDefault();
        this.props.onHiddenColumnsChange([]);
    }

    getColumnLabel(columnId) {
        const { t } = this.props;
        const info = getColumnData(t, columnId);
        if (!info) return columnId;
        const title = info.title || columnId;
        const subtitle = info.subtitle;
        return subtitle ? `${title} · ${subtitle}` : title;
    }

    renderColumnItem(columnId) {
        const isVisible = this.isColumnVisible(columnId);
        const itemClass = "column-visibility-item" + (isVisible ? ' -visible' : '');
        return (
            <li key={columnId}>
                <button
                    type="button"
                    className={itemClass}
                    onClick={() => this.handleToggleColumn(columnId)}
                >
                    <span className="column-visibility-item-check" aria-hidden="true">
                        {isVisible && <FaIcon iconName="check"/>}
                    </span>
                    <span className="column-visibility-item-label">
                        {this.getColumnLabel(columnId)}
                    </span>
                </button>
            </li>
        );
    }

    renderDropdown() {
        if (!this.state.isOpen) return null;
        const { t } = this.props;
        const activeColumns = this.props.activeColumns || [];
        const hiddenCount = this.getHiddenColumns().filter((c) => activeColumns.includes(c)).length;

        return (
            <div className="column-visibility-dropdown">
                <div className="column-visibility-dropdown-header">
                    <span className="column-visibility-dropdown-title">
                        {t('column_visibility.title')}
                    </span>
                </div>
                <ul className="column-visibility-list">
                    {activeColumns.map((columnId) => this.renderColumnItem(columnId))}
                </ul>
                <div className="column-visibility-dropdown-footer">
                    <button
                        type="button"
                        className="column-visibility-show-all"
                        onClick={this.handleShowAll}
                        disabled={hiddenCount === 0}
                    >
                        <FaIcon iconName="eye"/>
                        <span>{t('column_visibility.show_all')}</span>
                    </button>
                </div>
            </div>
        );
    }

    render() {
        const { t } = this.props;
        const activeColumns = this.props.activeColumns || [];
        const hiddenCount = this.getHiddenColumns().filter((c) => activeColumns.includes(c)).length;
        const isActive = hiddenCount > 0;
        const buttonClass = "column-visibility-button" + (isActive ? ' -active' : '');

        return (
            <div className="column-visibility" ref={this.containerRef}>
                <button
                    type="button"
                    className={buttonClass}
                    onClick={this.toggleDropdown}
                    title={t('column_visibility.title')}
                    aria-pressed={isActive}
                >
                    <FaIcon iconName={isActive ? 'eye-slash' : 'eye'}/>
                    {isActive && (
                        <span className="column-visibility-badge">{hiddenCount}</span>
                    )}
                </button>
                {this.renderDropdown()}
            </div>
        );
    }
}

export const ColumnVisibilityButton = withTranslation()(ColumnVisibilityButtonClass);
export default ColumnVisibilityButton;
